<footer>
  <p>{{ applicationName }} - Version: {{ applicationVersion }}</p>
  <p>AstraZeneca {{ copyrightYear }}</p>
</footer>
